export default __webpack_public_path__ + "static/media/txtLogo.8c8e5a2a.png";